/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * TopTopTime API
 * <:3 )~~~~    =^.^=
 * OpenAPI spec version: 0.0.1
 */

export enum GetUserBookingsPaymentStatus {
  PENDING_PAYMENT = 'PENDING_PAYMENT',
  PROCESSING_PAYMENT = 'PROCESSING_PAYMENT',
  PAYMENT_RECEIVED = 'PAYMENT_RECEIVED',
  FAILED = 'FAILED',
  REFUNDED = 'REFUNDED',
  EXPIRED = 'EXPIRED',
  CASH = 'CASH',
  FREE = 'FREE',
  DISPUTED = 'DISPUTED',
  PAYOUT_READY = 'PAYOUT_READY',
  PAID_OUT = 'PAID_OUT'
}
